export const intervalOptions = [
  { key: 'day', value: 'Daily' },
  { key: 'week', value: 'Weekly' },
  { key: 'month', value: 'Monthly' },
  { key: 'quarter', value: 'Quarter' },
  { key: 'year', value: 'Yearly' }];

export type IntervalTypes = 'day' | 'week' | 'month' | 'quarter' | 'year';

export const loadingProvider = (interval: IntervalTypes) => {
  const length = interval === 'day' ? 7 : interval === 'month' ? 12 : 4;
  return Array.apply(null, { length }).reduce((data, stat, index) => {
    const invalid = Math.floor(Math.random() * 100);
    const valid = Math.floor(Math.random() * 100);
    const randomStat = {
      date: index,
      faces: Math.floor(Math.random() * (valid + invalid)),
      invalid,
      valid
    };
    data.push(randomStat);
    return data;
  }, []);
}



// WEBPACK FOOTER //
// ./src/share/utils/intervals.ts